export default __webpack_public_path__ + "static/media/icon1.84d10ab4.png";